import React, { useState } from "react";
import Lightbox from 'react-18-image-lightbox';
import 'react-18-image-lightbox/style.css';

import Image1 from "../../assets/images/portfolio/finance.jpg";
import Image2 from "../../assets/images/portfolio/manufacturing.jpg";
import Image3 from "../../assets/images/portfolio/automobile.jpg";
import Image4 from "../../assets/images/portfolio/retail.jpg";
import Image5 from "../../assets/images/portfolio/supply-chain.jpg";
import Image6 from "../../assets/images/portfolio/6.jpg";
import Image7 from "../../assets/images/portfolio/construction.jpg";
import Image8 from "../../assets/images/portfolio/farming.jpg";


const images = [
    Image1,
    Image2,
    Image3,
    Image4,
    Image5,
    Image6,
    Image7,
    Image8
];

export default function Industries() {

    const [photoIndex, setActiveIndex] = useState(0);
    const [isOpen, setOpen] = useState(false);

    // const handleCLick = (index) => {
    //     setActiveIndex(index)
    //     setOpen(true);
    // }

    const projectList = [
        {

            image: Image1,
            title: 'Financial Services & Insurance',
            subtext: 'Branding'
        },
        {
            image: Image2,
            title: 'Manufacturing',
            subtext: 'Designing'
        },
        {
            image: Image4,
            title: 'Retail',
            subtext: 'Books'
        },
        {
            image: Image3,
            title: 'Automobile',
            subtext: 'Abstract'
        },
        {
            image: Image5,
            title: 'Supply Chain & Logistics',
            subtext: 'V-card'
        },
        {
            image: Image6,
            title: 'Services Industries',
            subtext: 'Photography'
        },
        {
            image: Image7,
            title: 'Real Estate & Construction',
            subtext: 'Cups'
        },
        {
            image: Image8,
            title: 'Farming & Agriculture',
            subtext: 'Article'
        }
    ]
    return (
        <>
            {/* Project Start  */}
            <section className="relative py-16 bg-gray-50 dark:bg-slate-800 active" id="portfolio">
                <div className="container">
                    <div className="grid grid-cols-1 pb-8 text-center">
                        <h6 className="text-blue-600 text-base font-medium uppercase mb-2">Industries We Support</h6>
                        <h3 className="mb-4 md:text-2xl text-xl font-medium dark:text-white">One platform. Multiple industries.</h3>
                        <p className="text-slate-500 dark:text-slate-300 max-w-xl mx-auto">SATTVA is an all-in-one ESG management tool supporting businesses of all sizes. The platform delivers transparency, risk visibility, and alignment with global ESG standards.</p>
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-4 md:grid-cols-2 gap-6 mt-8">
                        {/* {projectList.map((item, index) => (
                            <div className="relative rounded-md shadow-sm overflow-hidden group" key={index}>
                                <img src={item.image} className="group-hover:origin-center group-hover:scale-110 group-hover:rotate-3 transition duration-500" alt="workimage" />
                                <div className="absolute inset-0 group-hover:bg-black opacity-50 transition duration-500 z-0"></div>

                                <div className="content">
                                    <div className="icon absolute z-10 opacity-0 group-hover:opacity-100 top-4 end-4 transition-all duration-500">
                                        <Link to="/portfolio-detail" onClick={() => handleCLick(index)} className="btn bg-blue-600 hover:bg-blue-700 border-blue-600 hover:border-blue-700 text-white btn-icon rounded-full lightbox">
                                            <i className="uil uil-camera"></i></Link>
                                    </div>
                                    <div className="absolute z-10 opacity-0 group-hover:opacity-100 bottom-4 start-4 transition-all duration-500">
                                        <Link to="/portfolio-detail" className="h6 text-md font-medium text-white hover:text-white-600 transition duration-500">{item.title}</Link>
                                        <p className="text-slate-100 tag mb-0">{item.subtext}</p>
                                    </div>
                                </div>
                            </div>
                        ))} */}
                        {projectList.map((item, index) => (
                            <div
                                key={index}
                                className="relative rounded-md shadow-sm overflow-hidden group"
                            >
                                <img
                                    src={item.image}
                                    alt="workimage"
                                    className="w-full h-full object-cover transition duration-500 group-hover:scale-110"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent z-0" />
                                <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition duration-500 z-0" />
                                <div className="absolute bottom-4 px-2 z-10">
                                    <h3 className="relative text-white text-md font-semibold transition-all duration-500 group-hover:-translate-y-2 group-hover:text-green-500">
                                        {item.title}
                                        <span className="absolute left-0 -bottom-1 h-[2px] w-0 bg-green-500 text-green-500 transition-all duration-500 group-hover:w-full" />
                                    </h3>
                                </div>
                            </div>
                        ))}
                    </div>
                    {isOpen && (
                        <Lightbox
                            mainSrc={images[photoIndex]}
                            nextSrc={images[(photoIndex + 1) % images.length]}
                            prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                            onCloseRequest={() => setOpen({ isOpen: false })}
                            onMovePrevRequest={() =>
                                setActiveIndex((photoIndex + images.length - 1) % images.length,
                                )
                            }
                            onMoveNextRequest={() =>
                                setActiveIndex((photoIndex + 1) % images.length,
                                )
                            }
                        />
                    )}
                </div>
            </section>          
        </>
    );

}
